import React from 'react';

import { useBasicQuery, useDeleteBasicItemMutation, useUpdateBasicItemMutation } from '../../../generated/graphql';
import deletePageItem from '../../../helpers/apolloCache/deletePageItem';
import { useManageItem } from '../../../helpers/useManageItem';
import Layout from '../../FormComponents/Layout';
import { pagesQuery } from '../../LeftContainer/graphql';
import Form, { InitialValues, initialValues, validationSchema } from '../StoryItem/Form';

export interface PageItemProps {
  preview?: boolean;
  onSaveHandler?: () => void;
  onBackHandler?: () => void;
}

export const BasicItem: React.FC<PageItemProps> = ({ onSaveHandler }) => {
  const { pageId, itemId, isNew, close } = useManageItem();
  const [update, { loading: updating }] = useUpdateBasicItemMutation();
  const [destroy, { loading: destroying }] = useDeleteBasicItemMutation();

  const { data, loading } = useBasicQuery({
    variables: {
      pageId,
      id: itemId!,
    },
    skip: isNew,
  });
  const item = data?.page?.basicItem;

  const deleteBasic = async () => {
    if (itemId) {
      await destroy({
        variables: {
          id: itemId,
          pageId,
        },
        update(cache) {
          deletePageItem({ pageId, itemId, cache });
        },
        refetchQueries: [{ query: pagesQuery }],
      });
    }
  };

  const save = async (values: InitialValues): Promise<void> => {
    const { mediaUrl, aspectRatio, __typename, ...rest } = values.photo;

    let photoData = {
      photo: {
        ...rest,
      },
    };

    if (item?.id) {
      await update({
        variables: {
          attributes: {
            id: item?.id,
            pageId: pageId,
            title: values.title || '',
            description: values.description || null,
            ...photoData,
          },
        },
        update: (_cache, { data }) => close(data?.updateBasicItem),
      });
    }
    if (onSaveHandler) {
      onSaveHandler();
    }
  };

  return (
    <Layout
      headerText="Update Page Item"
      validationSchema={validationSchema}
      initialValues={initialValues(item)}
      onSubmit={save}
      Component={Form}
      loading={loading}
      updating={updating || destroying}
      onDelete={deleteBasic}
      close={close}
      item={item}
      pageId={pageId}
      isNew={isNew}
    />
  );
};
